// extracted by mini-css-extract-plugin
module.exports = {"infrastructure-rows":"_02712f2b3b--infrastructure-rows--fdOT_","non-clickable-heading-wrapper":"_02712f2b3b--non-clickable-heading-wrapper--Nc3GG"};